import {useCallback} from 'react';
import {IS_CLIENT} from '../../common/constant';
import useLocalStorageMap from '../../common/hook/useLocalStorageMap';
import {getLocalStorageObject} from '../../common/util/storage';
import {VIEWER_LS_KEY_LAST_PAGE} from '../../commonSub/constant';
import {getViewerLsMapKey} from '../common';

// TODO: last페이지가 바뀔 때 반응을 하면 안되서 hook은 의도에 안맞지만, maxLength 처리를 위해 사용
// 로직을 분리해서 hook이 아니어도 함꼐 사용할 수 있도록 처리해보자.
export default function useLastPage({
  contentId: contendId,
  episodeId,
  needDebounce = true,
}: {
  contentId?: number;
  episodeId: number;
  needDebounce?: boolean;
}): {lastPage: number | undefined; saveLastPage: (page: number) => void} {
  const [lastPageMap, mergeLastPage] = useLocalStorageMap<number>({
    key: VIEWER_LS_KEY_LAST_PAGE,
    needDebounce,
  });

  const saveLastPage = useCallback(
    (page: number) => {
      contendId &&
        mergeLastPage({[getViewerLsMapKey(contendId, episodeId)]: page});
    },
    [contendId, episodeId, mergeLastPage]
  );

  return {
    lastPage: contendId
      ? lastPageMap[getViewerLsMapKey(contendId, episodeId)]
      : 0,
    saveLastPage,
  };
}

export function getLastPage(contentId: number, episodeId: number) {
  if (IS_CLIENT) {
    const lastPageMap = getLocalStorageObject<{[key: string]: number}>({
      key: VIEWER_LS_KEY_LAST_PAGE,
    });
    return lastPageMap?.[getViewerLsMapKey(contentId, episodeId)];
  }
}
